import styled from 'styled-components';

import { SmallTitle, style } from '@genially/design-system';
import { CopyIcon } from '@genially/icons';

import { ResponsiveText } from '../../../../../../../../shared/application/components/ResponsiveText/ResponsiveText';
import { HostLobbyBreakdownSteps } from '../../HostLobby.constants';

export const QRCodeWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',

  ...style.mixins.responsive.xs.downward({
    width: size.units(10),
    height: size.units(10),
  }),
}));

export const StyledSmallTitle = styled(SmallTitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const StyledResponsiveTitle = styled(ResponsiveText)(({ theme: { color } }) => ({
  color: color.content.primary.disabled(),
  textAlign: 'center',
}));

export const StyledResponsiveSubtitle = styled(ResponsiveText)(
  ({ theme: { color } }) => ({
    color: color.content.reversed.default(),
    textAlign: 'center',

    ...style.mixins.responsive.xs.downward({
      textAlign: 'left',
    }),
  }),
);

export const StyledResponsiveSessionId = styled(ResponsiveText)(
  ({ theme: { color } }) => ({
    color: color.content.reversed.default(),
    textAlign: 'center',
  }),
);

export const SessionCodeWrapper = styled.div(({ theme: { size, transition } }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: size.units(2),
  cursor: 'pointer',
  transition: transition.standard(),

  ':hover': {
    transform: 'scale(0.95)',
  },
}));

export const ButtonWrapper = styled.div({});

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100%',
  justifyContent: 'center',

  ...style.mixins.responsive.xs.downward({
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: size.units(2),
  }),
}));

export const Content = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  [StyledResponsiveTitle]: {
    marginTop: size.units(3),
  },

  [StyledResponsiveSubtitle]: {
    marginTop: size.units(2),
  },

  [StyledResponsiveSessionId]: {
    marginTop: size.units(1),
  },

  [ButtonWrapper]: {
    marginTop: size.units(2),
  },

  ...style.mixins.responsive.xs.downward({
    alignItems: 'flex-start',
    gap: size.units(0.5),

    [StyledResponsiveSubtitle]: {
      marginTop: 0,
    },

    [StyledResponsiveSessionId]: {
      marginTop: 0,
    },
  }),
}));

export const SessionIdWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: size.units(1),
}));

export const StyledCopyIcon = styled(CopyIcon)(({ theme: { color, size } }) => ({
  color: color.content.reversed.default(),

  ...style.mixins.responsive.custom(`${HostLobbyBreakdownSteps.second}px`).downward({
    width: size.units(2),
    height: size.units(2),
  }),
}));
